import { Box, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiShield } from "react-icons/fi";
import type { MinimumRequirementDto } from "../../../../autogen/bff-api";
import { TipTap } from "../../../../common/input/TipTap/TipTap";
import { MinimumRequirementResponseTypeBadge } from "../../buyer/public/components/MinimumRequirementResponseTypeBadge";
import { SectionCard } from "./SectionCard";

export const MinimumRequirementsSection = ({ requirements }: { requirements: MinimumRequirementDto[] }) => {
  const { t } = useTranslation();
  if (requirements.length === 0) return null;

  return (
    <SectionCard icon={FiShield} title={t("Minimum requirements")} count={requirements.length}>
      <Stack spacing="3">
        {requirements.map((requirement, index) => (
          <Box
            key={requirement.id ?? `${requirement.title}-${index}`}
            borderWidth="1px"
            borderColor="smBorder"
            rounded="md"
            px="4"
            py="3"
            bg="smBackground"
          >
            <Stack spacing="2">
              <Box>
                <MinimumRequirementResponseTypeBadge responseType={requirement.responseType} />
              </Box>
              <Text fontWeight="semibold" color="smText" fontSize="sm">
                {requirement.title}
              </Text>
              {requirement.description && (
                <TipTap content={requirement.description} editable={false} hasBorder={false} padding="0" maxHeight="" />
              )}
            </Stack>
          </Box>
        ))}
      </Stack>
    </SectionCard>
  );
};
